import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserBox from 'components/UserBox';
import Button from 'components/Button';
import makeModal from 'components/Modals';

export class ConfirmBase extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onConfirm();
    this.props.close();
  };

  render() {
    const { close, title, info } = this.props;
    return (
      <UserBox
        id="confirmBox"
        className="confirm modal modal--inline"
        title={title}
        closeCallback={close}
      >
        <form onSubmit={this.handleSubmit}>
          <p>{info}</p>
          <div className="fieldset fieldset--centerflex">
            <Button
              className="submit"
              title="Go back"
              type="button"
              name="close"
              id="confirm-close"
              buttonText="Go back"
              onClick={close}
            />
            <Button className="submit" title="Confirm" buttonText="Confirm" type="submit" />
          </div>
        </form>
      </UserBox>
    );
  }
}

ConfirmBase.propTypes = {
  close: PropTypes.func,
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired
};

ConfirmBase.defaultProps = {
  close: null
};

export default makeModal(
  'confirm',
  { name: 'modal-fade', timeout: 200 },
  { className: 'confirm modal modal--inline' }
)(ConfirmBase);
